import { genericPage, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
const path = ['web', process.env.FOLDER_LAYOUTS, 'tot-cataleg', 'tipus'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { canal } = context.query;
    const allowedCanals = [
        'series',
        'entreteniment',
        'podcasts',
        'actualitat',
        'esports',
        'sx3',
        'campus',
        'cultura',
        'pellicules',
        'documentals-i-reportatges',
        'eva',
        'cuines',
        'tot'
    ];
    if (!allowedCanals.includes(canal)) {
        return {
            notFound: true
        };
    }
    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
